
import { FaBalanceScale, FaUniversity } from "react-icons/fa";
import { HiOutlineDocumentText } from "react-icons/hi";
import "../Three/Three.css";

const cards = [
  {
    icon: <FaUniversity />,
    title: "EXPERT LEGAL COUNSEL",
    description:
      "Our team offer strategic legal advice and representation tailored to your unique needs, helping you navigate complex legal systems."
  },
  {
    icon: <HiOutlineDocumentText />,
    title: "SECURE & CONFIDENTIAL",
    description:
      "We treat your personal and case-related information with utmost confidentiality. Your trust and privacy are always protected."
  },
  {
    icon: <FaBalanceScale />,
    title: "TRUSTED LEGAL DEFENSE",
    description:
      "We deliver strong legal defense to protect your rights and interests. Our team ensures every legal safeguard is in place for your protection."
  }
];

export default function LawFirmHighlights() {
  return (
    <section className="law-highlights">
      <div className="law-card-container">
        {cards.map((card, index) => (
          <div className="law-card" key={index}>
            <div className="law-icon">{card.icon}</div>
            <h3 className="law-title">{card.title}</h3>
            <p className="law-text">{card.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
